import React, { Component } from 'react';
import './progress.scss';

export default class Progress extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { style, className } = this.props;
    const cls = [className, 'lf-progress'].join(' ');

    return (
      <div className={cls} style={style}>
        <span className="lf-progress-desc">{this.props.rate}%</span>
        <div className="lf-progress-rate" style={{ width: `${this.props.rate}%` }}></div>
      </div>
    );
  }
}
